import React from 'react';

import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const Close = Styled(
	createSvgIcon(
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M8.00004 14.6668C11.6667 14.6668 14.6667 11.6668 14.6667 8.00016C14.6667 4.3335 11.6667 1.3335 8.00004 1.3335C4.33337 1.3335 1.33337 4.3335 1.33337 8.00016C1.33337 11.6668 4.33337 14.6668 8.00004 14.6668Z'
				stroke='currentColor'
				strokeWidth='1.2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.11328 9.88661L9.88661 6.11328'
				stroke='currentColor'
				strokeWidth='1.2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.88661 9.88661L6.11328 6.11328'
				stroke='currentColor'
				strokeWidth='1.2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'Close'
	)
);

export default Close;
